import SpeakerSelect from "./SpeakerSelect";
import HeadingSelect from "./HeadingSelect";
const FiltersBar = ({
  speakers,
  selectedSpeakers,
  onSpeakersChange,
  headings,
  selectedHeadings,
  onHeadingsChange,
  expanded = true,
}) => {
  return (
    <div className="flex flex-col w-full">
      {expanded ? (
        <div className="flex gap-4 items-center overflow-x-auto flex-nowrap">
          <div className="shrink-0">
            <SpeakerSelect
              speakers={speakers}
              selectedKeys={selectedSpeakers}
              onSelectionChange={onSpeakersChange}
            />
          </div>
          <div className="shrink-0">
            <HeadingSelect
              headings={headings}
              selectedKeys={selectedHeadings}
              onSelectionChange={onHeadingsChange}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FiltersBar;
